import type { SQLocalDrizzle } from 'sqlocal/drizzle';

import journal from '$lib/client/db/drizzle/meta/_journal.json';

export async function migrate(ctx: SQLocalDrizzle) {
	const migrations = import.meta.glob<string>('$lib/client/db/drizzle/*.sql', {
		import: 'default',
		eager: true,
		query: { raw: '' }
	});

	await ctx.sql`
    CREATE TABLE IF NOT EXISTS __migrations (
      id SERIAL PRIMARY KEY,
      hash TEXT NOT NULL,
      created_at NUMERIC
    )`;

	const dbMigrations = await ctx.sql<{ created_at: number }>`
    SELECT id, hash, created_at
    FROM __migrations
    ORDER BY created_at DESC LIMIT 1`;

	const lastDbMigration = dbMigrations.at(0);

	const migrationsPath = '/src/lib/client/db/drizzle';
	const migrationsToApply = await Promise.all(
		journal.entries.map(async (journalEntry) => {
			const contents = migrations[`${migrationsPath}/${journalEntry.tag}.sql`];
			const statements = contents.split('--> statement-breakpoint');
			const hash = await digestMessage(contents);
			return {
				sql: statements,
				bps: journalEntry.breakpoints,
				folderMillis: journalEntry.when,
				hash
			};
		})
	);

	await ctx.transaction(async (tx) => {
		for (const migration of migrationsToApply) {
			if (!lastDbMigration || lastDbMigration.created_at < migration.folderMillis) {
				for (const stmt of migration.sql) {
					if (stmt.trim()) {
						await tx.sql(stmt);
					}
				}

				await tx.sql(`
          INSERT INTO __migrations ("hash", "created_at")
          VALUES('${migration.hash}', ${migration.folderMillis})`);
			}
		}
	});
}

async function digestMessage(message: string) {
	const buf = new TextEncoder().encode(message);
	const hashBuf = await crypto.subtle.digest('SHA-256', buf);
	const hashArr = Array.from(new Uint8Array(hashBuf));
	const hashHex = hashArr.map((b) => b.toString(16).padStart(2, '0')).join('');
	return hashHex;
}
